import { LIST_ROWS_PER_PAGE } from '../constants';
import axiosInstance from './api';
import { normalizeAppUsersListResponse as normalizeAppUsersListResponseModel } from '../utils/usersModel';

export { formatUserGender, normalizeAppUser } from '../utils/usersModel';

const getApiErrorMessage = (error, fallback) => {
  if (!error) return fallback;
  if (typeof error === 'string') return error;
  return error.message || error?.error?.message || error?.data?.message || fallback;
};

/** GET /admin/app-users — all platform users (admin-only).
 * Query: page, limit, search?
 */
export const listAppUsers = async (params = {}) => {
  try {
    const response = await axiosInstance.get('/admin/app-users', { params });
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      message: getApiErrorMessage(error, 'Failed to fetch users'),
      error,
    };
  }
};

export const normalizeAppUsersListResponse = (payload, params = {}) =>
  normalizeAppUsersListResponseModel(payload, {
    ...params,
    limit: params.limit ?? LIST_ROWS_PER_PAGE,
  });

/** POST /admin/app-users/:userId/ban — bans a platform user. */
export const banAppUser = async (userId) => {
  try {
    const response = await axiosInstance.post(`/admin/app-users/${userId}/ban`);
    return {
      success: true,
      data: response.data?.data ?? response.data,
      message: response.data?.message || 'User banned successfully',
    };
  } catch (error) {
    return {
      success: false,
      message: getApiErrorMessage(error, 'Failed to ban user'),
      error,
    };
  }
};
